import React from 'react';
import { images } from '../../constants';
import { FiArrowRight, FiCheckCircle } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="site-container hero-grid">
        <div className="hero-copy">
          <span className="eyebrow">Enterprise AI initiatives</span>
          <h1 className="title">AI systems for data-rich enterprises.</h1>
          <p className="hero-lede">
            SmartSastram engineers applied AI products and platforms for organizations turning data, language, and real-world operations into dependable intelligence.
          </p>

          <div className="hero-actions">
            <a href="#dataface" className="btn-primary-site">Explore Data + AI <FiArrowRight /></a>
            <a href="#quote" className="btn-secondary-site">Discuss an initiative</a>
          </div>

          <div className="hero-proof" aria-label="Company focus areas">
            <div>
              <span>01</span>
              <strong>Data + AI</strong>
              <small>Dataface.ai</small>
            </div>
            <div>
              <span>02</span>
              <strong>Voice AI</strong>
              <small>Research and roadmap</small>
            </div>
            <div>
              <span>03</span>
              <strong>Physical AI</strong>
              <small>Deeptech direction</small>
            </div>
          </div>
        </div>

        <div className="hero-visual" aria-label="AI product visualization">
          <img src={images.hero} alt="Enterprise AI interface concept" />
          <div className="hero-system-panel">
            <span>Dataface.ai</span>
            <h2>Data-to-AI operating layer</h2>
            <ul>
              <li><FiCheckCircle /> Data workflows</li>
              <li><FiCheckCircle /> AI evaluation</li>
              <li><FiCheckCircle /> Enterprise controls</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
